import { useCallback, useEffect, useState } from "react";
import { styled } from "@mui/material";
import { Layer, LayerEvent, Map } from "leaflet";
import { AttributionControlProps } from "react-leaflet";

interface Props extends AttributionControlProps {
  map: Map;
}

export function AttributionDisplay(props: Props) {
  const { map, prefix } = props;
  const [attributions, setAttributions] = useState<string[]>([]);
  const addAttributionCallback = useCallback(addAttribution, [attributions]);
  const removeAttributionCallback = useCallback(removeAttribution, [
    attributions,
  ]);
  const layerAddCallback = useCallback(onLayerAdd, [
    addAttributionCallback,
    removeAttributionCallback,
  ]);

  useEffect(() => {
    map.eachLayer((layer: Layer) => {
      if (layer && layer.getAttribution) {
        addAttributionCallback(layer.getAttribution());
      }
    });

    map.on("layeradd", layerAddCallback);

    return () => {
      map.off("layeradd", layerAddCallback);
    };
  }, [map, layerAddCallback, addAttributionCallback]);

  function onLayerAdd(event: LayerEvent) {
    if (event.layer && event.layer.getAttribution) {
      addAttributionCallback(event.layer.getAttribution());
      event.layer.once("remove", function () {
        if (event.layer && event.layer.getAttribution)
          removeAttributionCallback(event.layer.getAttribution());
      });
    }
  }

  function removeAttribution(text: string | null) {
    if (text) setAttributions(attributions.filter((attr) => attr !== text));
  }

  function addAttribution(text: string | null) {
    if (text && !attributions.includes(text))
      setAttributions([...attributions, text]);
  }

  return (
    <Styles>
      {prefix && (
        <span>
          {prefix}
          <span aria-hidden="true">|</span>
        </span>
      )}
      {attributions.map((attr) => (
        <span key={attr} className="separator">
          {attr}
        </span>
      ))}
    </Styles>
  );
}

const Styles = styled("div")``;
